import { apiRequest } from "../util/apiUtils";

export const socialLogin = async (payload) => {
  try {
    const res = await apiRequest("post", `glogin-cred`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const socialLoginApple = async (payload) => {
  try {
    const res = await apiRequest("post", `apl-login`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
